<template>
  <div class="stratQuestion" :style="'background:url(' + contenttest.quiz_background + ')'">
    <div class="header-stratQuestion">
      <h3>{{ contenttest.quiz_name }}</h3>
    </div>
    <div class="content-stratQuestion">
      <span>{{ contenttest.quiz_description }}</span>
    </div>
    <div class="btns-stratQuestion">
      <router-link
        :to="{ name: 'singleQuestion', query: { id: contenttest.quiz_id } }"
      >
        <div class="btn-start">
          <span>شروع تست</span>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import oracle from "@/oracle";
export default {
  name: "stratQuestion",
  data: () => ({
    contenttest: "",
  }),
  methods: {
    gettest(res) {
      this.contenttest = res.data;
    },
  },
  mounted() {
    const id = this.$route.query.id;
    oracle.axios("quiz/getOne", { quiz_id: id }, this.gettest);
  },
};
</script>
<style>
.stratQuestion {
  position: relative;
  background-size: cover;
  padding: 0;
  height: 100%;
  overflow: hidden;
}
.content-stratQuestion {
  height: 80vh;
  overflow: auto;
  background: rgba(255, 255, 255, 0.5);
  margin: 60px 15px;
  padding: 20px;
}
.content-stratQuestion span {
  font-size: 13px;
  padding-top: 15px;
  font-weight: bold;
  padding-bottom: 10px;
}
.btns-stratQuestion .btn-start {
  align-items: center;
  display: flex;
  color: #fff;
  margin: 0 4px 0 4px;
  padding: 20px;
  font-size: 13px;
  border-radius: 5px;
  background: #50ac17;
}
.btns-stratQuestion {
  display: flex;
  position: absolute;
  bottom: 35px;
  width: 100%;
  text-align: center;
  align-content: center;
  justify-content: center;
  z-index: 101;
}
.header-stratQuestion h3 {
  font-size: 12px;
  color: #0000cd;
}
.header-stratQuestion {
  display: flex;
  justify-content: center;
  margin-top: 25px;
  z-index: 101;
}
</style>
